import * as React from "react";

export const Header = () => (
  <header>
    <h1>International Telephone Number</h1>
  </header>
);
